
      <!-- ═══════════════════════ HEADER + FILTER BAR ═══════════════════════ -->
      <div class="mx-auto mb-6 animate-fade-up delay-1">
      
        <!-- Title row -->
        <div class="flex flex-col sm:flex-row sm:items-end justify-between mb-5 gap-4">
          <div>
            <h2 class="text-3xl md:text-4xl font-extrabold leading-tight">
              <span class="bg-clip-text text-transparent bg-gradient-to-r from-indigo-600 to-violet-600">
                All Users
              </span>
              <span class="text-base sm:text-lg text-gray-400 font-semibold ml-1">
                ({{ totalUsersCount() }})
              </span>
            </h2>
            <div class="w-12 h-1.5 rounded-full mt-2.5"
                 style="background:linear-gradient(90deg,#6366f1,#8b5cf6)"></div>
          </div>
      
          <button
            (click)="exportUsersCSV()"
            *ngIf="isRoteHasPermissions('canOnboardAdvisor')"
            class="group w-full sm:w-auto min-h-[44px] inline-flex items-center justify-center gap-2
                   px-5 py-3 text-sm font-bold rounded-xl text-white
                   bg-emerald-500 hover:bg-emerald-600 active:scale-95
                   transition-all shadow-md shadow-emerald-200
                   focus-visible:ring-2 focus-visible:ring-emerald-400 focus-visible:ring-offset-2">
            <svg class="w-4 h-4 group-hover:translate-y-0.5 transition-transform duration-200"
                 fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 4v12m0 0l-4-4m4 4l4-4M4 20h16"/>
            </svg>
            Export CSV
          </button>
        </div>
      
        <!-- Filter bar -->
        <div class="filter-bar mb-5 p-3 sm:p-4 bg-white rounded-2xl border border-gray-100 shadow-sm
                    flex flex-col gap-3 lg:flex-row lg:items-center">
      
          <!-- Search -->
          <div class="relative flex-1 min-w-0">
            <input
              type="text"
              placeholder="Search by name, email or mobile…"
              (input)="onSearchChange($any($event.target).value)"
              class="input-field w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-xl text-sm
                     bg-gray-50 focus:bg-white focus:border-indigo-400 outline-none
                     focus:ring-2 focus:ring-indigo-500/20 transition-all" />
            <svg class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none"
                 fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
            </svg>
          </div>
      
          <!-- Selects grid -->
          <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3 lg:flex lg:items-center lg:gap-3">
      
            <!-- Approval filter -->
            <div class="relative">
              <select
                 (change)="onApprovalOrTypeChange($any($event.target).value)"
                class="input-field appearance-none w-full px-4 py-2.5 pr-9 text-sm font-medium text-gray-700
                       bg-white border border-gray-200 rounded-xl outline-none
                       hover:border-gray-300 focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-400
                       transition-all cursor-pointer lg:min-w-[180px]">
                <option value="ALL">All Approval ({{ totalUsersCount() }})</option>
                <option value="Premium">Paid Users ({{ premiumUsersCount() }})</option>
                <option value="Approved">Approved ({{ approvedUsersCount() }})</option>
                <option value="Pending">Pending ({{ pendingUsersCount() }})</option>
                <option value="Rejected">Rejected ({{ rejectedUsersCount() }})</option>
              </select>
              <svg class="absolute right-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400 pointer-events-none"
                   fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M19 9l-7 7-7-7"/>
              </svg>
            </div>
      
            <!-- Advisor status filter -->
            <div class="relative">
              <select
                (change)="advisorStatusFilter.set($any($event.target).value)"
                class="input-field appearance-none w-full px-4 py-2.5 pr-9 text-sm font-medium text-gray-700
                       bg-white border border-gray-200 rounded-xl outline-none
                       hover:border-gray-300 focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-400
                       transition-all cursor-pointer lg:min-w-[170px]">
                <option value="ALL">All Advisor Status</option>
                <option value="ASSIGNED">Assigned</option>
                <option value="NOT_ASSIGNED">Not Assigned</option>
              </select>
              <svg class="absolute right-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400 pointer-events-none"
                   fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M19 9l-7 7-7-7"/>
              </svg>
            </div>
      
            <!-- Assigned advisor filter -->
            <div class="relative" *ngIf="!isSalesAdvisor()">
              <select
                [value]="advisorFilter()"
                (change)="advisorFilter.set($any($event.target).value)"
                class="input-field appearance-none w-full px-4 py-2.5 pr-9 text-sm font-medium text-gray-700
                       bg-white border border-gray-200 rounded-xl outline-none
                       hover:border-gray-300 focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-400
                       transition-all cursor-pointer lg:min-w-[160px]">
                <option value="ALL">All Advisors</option>
                <option *ngFor="let adv of uniqueAdvisors()" [value]="adv.id">{{ adv.name }}</option>
              </select>
              <svg class="absolute right-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400 pointer-events-none"
                   fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M19 9l-7 7-7-7"/>
              </svg>
            </div>
          </div>
      
          <!-- Add user button -->
          <button
            (click)="showUserModal = true"
            class="w-full lg:w-auto min-h-[44px] inline-flex items-center justify-center gap-2 text-nowrap
                   px-6 py-3 text-sm font-bold rounded-xl text-white
                   bg-indigo-600 hover:bg-indigo-700 active:scale-95
                   transition-all shadow-md shadow-indigo-200
                   focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M12 4v16m8-8H4"/>
            </svg>
            Add New User
          </button>
        </div>
      </div>
      
      <!-- Sales advisor info bar -->
      <div *ngIf="isSalesAdvisor()"
           class="animate-fade-up delay-2 mb-4 flex items-center gap-2 text-sm text-gray-500
                  bg-indigo-50 border border-indigo-100 rounded-xl px-4 py-2.5">
        <svg class="w-4 h-4 text-indigo-400 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
        Showing users assigned to
        <span class="font-bold text-indigo-700">{{ user()?.name }}</span>
      </div>
      
      
      <!-- ═══════════════════════ TABLE ═══════════════════════ -->
      <div class="animate-fade-up delay-3 bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden">
        <div class="overflow-x-auto">
          <table class="w-full text-left border-collapse" style="min-width:840px">
      
            <thead>
              <tr class="bg-gray-50/80 border-b border-gray-200">
                <th class="px-4 lg:px-6 py-4 text-[10px] font-black text-gray-400 uppercase tracking-widest">
                  User Details
                </th>
                <th class="px-4 lg:px-6 py-4 text-[10px] font-black text-gray-400 uppercase tracking-widest">
                  Type
                </th>
                <th class="px-4 lg:px-6 py-4 text-[10px] font-black text-gray-400 uppercase tracking-widest">
                  Created / Updated
                </th>
                <th class="px-4 lg:px-6 py-4 text-[10px] font-black text-gray-400 uppercase tracking-widest hidden lg:table-cell">
                  Contact Info
                </th>
                <th class="px-4 lg:px-6 py-4 text-[10px] font-black text-gray-400 uppercase tracking-widest hidden lg:table-cell">
                  Approval
                </th>
                <th class="px-4 lg:px-6 py-4 text-[10px] font-black text-gray-400 uppercase tracking-widest hidden xl:table-cell text-center">
                  Requests
                </th>
                <th class="px-4 lg:px-6 py-4 text-[10px] font-black text-gray-400 uppercase tracking-widest">
                  Advisor
                </th>
                <th class="px-4 lg:px-6 py-4 text-[10px] font-black text-gray-400 uppercase tracking-widest text-right">
                  Actions
                </th>
              </tr>
            </thead>
      
            <tbody class="divide-y divide-gray-100 text-sm">
              @for (user of paginatedUsers(); track user._id) {
              <tr class="table-row table-row-animate cursor-pointer"
                  [class.bg-indigo-50]="selectedUser()?._id === user._id">
      
                <!-- ── User Details ── -->
                <td class="px-4 lg:px-6 py-3.5" (click)="selectUser(user)">
                  <div class="flex items-center gap-3 min-w-[170px]">
                    <!-- Avatar initial -->
                    <div class="w-8 h-8 rounded-full bg-indigo-100 text-indigo-700 font-black text-xs
                                flex items-center justify-center shrink-0 ring-2 ring-white shadow-sm select-none">
                      {{ user?.name?.charAt(0)?.toUpperCase() }}
                    </div>
                    <div class="min-w-0">
                      <div class="font-bold text-gray-900 text-sm flex flex-wrap items-center gap-1.5">
                        <span class="truncate">{{ user.name }}</span>
                        <span
                          *ngIf="user?.state == 'Pending' && isNewUser(user.createdAt)"
                          class="new-user-badge"
                          title="Joined within the last 7 days">
                          <span class="ping-ring"></span>
                          <span class="live-dot"></span>
                          <span class="badge-label">NEW</span>
                        </span>
                      </div>
                      <!-- Phone shown only on small screens -->
                      <div class="text-xs text-gray-400 mt-0.5 lg:hidden truncate">
                        {{ user?.country?.dial }}{{ user.phone }}
                      </div>
                    </div>
                  </div>
                </td>
      
                <!-- ── Type ── -->
                <td class="px-3 lg:px-4 py-3.5 whitespace-nowrap">
                  <span
                    *ngIf="user.isUserType !== 'Premium'"
                    class="inline-flex items-center px-2.5 py-1 rounded-lg text-[10px] uppercase tracking-wider font-bold
                           border bg-indigo-50 text-indigo-700 border-indigo-100">
                    {{ user.isUserType }}
                  </span>
                  <span
                    *ngIf="user.isUserType === 'Premium'"
                    class="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[10px] font-black uppercase tracking-wider
                           bg-gradient-to-r from-amber-400 to-orange-500 text-white shadow-sm
                           cursor-pointer transition-all duration-200 hover:shadow-md hover:scale-105 active:scale-95">
                    <svg class="w-3 h-3 shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                    </svg>
                    Premium
                  </span>
                </td>
      
                <!-- ── Created / Updated ── -->
                <td class="px-3 lg:px-4 py-3.5 whitespace-nowrap">
                  <div class="flex flex-col gap-0.5">
                    <span class="text-[11px] text-gray-400">
                      <span class="font-semibold text-gray-500">Created:</span>
                      {{ user.createdAt | date:'dd MMM yyyy, hh:mm a' }}
                    </span>
                    <span class="text-[11px] text-gray-400">
                      <span class="font-semibold text-gray-500">Updated:</span>
                      {{ user.updatedAt | date:'dd MMM yyyy, hh:mm a' }}
                    </span>
                  </div>
                </td>
      
                <!-- ── Contact Info ── -->
                <td class="px-4 lg:px-6 py-3.5 whitespace-nowrap hidden lg:table-cell">
                  <div class="flex flex-col gap-1.5">
                    <a [href]="'tel:' + user.phone"
                       class="flex items-center gap-2 text-sm text-gray-600 font-medium
                              hover:text-indigo-600 transition-colors group/link">
                      <div class="p-1 bg-gray-100 rounded-md group-hover/link:bg-indigo-100 transition-colors">
                        <svg class="w-3.5 h-3.5 text-gray-500 group-hover/link:text-indigo-600 transition-colors"
                             fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                        </svg>
                      </div>
                      {{ user?.country?.dial }} {{ user.phone }}
                    </a>
                    <a [href]="'mailto:' + user.email"
                       class="flex items-center gap-2 text-xs text-gray-400
                              hover:text-indigo-600 transition-colors group/link">
                      <div class="p-1 bg-gray-100 rounded-md group-hover/link:bg-indigo-100 transition-colors">
                        <svg class="w-3.5 h-3.5 text-gray-500 group-hover/link:text-indigo-600 transition-colors"
                             fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                        </svg>
                      </div>
                      <span class="truncate max-w-[140px]">{{ user.email }}</span>
                    </a>
                  </div>
                </td>
      
                <!-- ── Approval ── -->
                <td class="px-4 lg:px-6 py-3.5 whitespace-nowrap hidden lg:table-cell">
                  <span
                    class="px-3 py-1 rounded-full font-black text-[11px] uppercase tracking-wider border"
                    [class]="_US.getStatusClass(user?.state)">
                    {{ user?.state || 'Pending' }}
                  </span>
                </td>
      
                <!-- ── Requests ── -->
                <td class="px-4 lg:px-6 py-3.5 whitespace-nowrap hidden xl:table-cell text-center">
                  <span class="mono bg-gray-100 px-2.5 py-1 rounded-lg font-bold text-gray-700 text-xs">
                    {{ user.requestsCount || '00' }}
                  </span>
                </td>
      
                <!-- ── Advisor ── -->
                <td class="px-4 lg:px-6 py-3.5 whitespace-nowrap">
                  <div class="flex flex-col gap-1.5">
                    <span
                      *ngIf="isAdvisorAssigned(user); else notAssigned"
                      class="inline-flex items-center w-fit gap-1.5 px-2 py-0.5 rounded-full
                             text-[10px] font-black ring-1 ring-inset
                             bg-emerald-50 text-emerald-700 ring-emerald-600/20">
                      <span class="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse shrink-0"></span>
                      ASSIGNED
                    </span>
                    <ng-template #notAssigned>
                      <span class="inline-flex items-center w-fit gap-1.5 px-2 py-0.5 rounded-full
                                   text-[10px] font-black ring-1 ring-inset
                                   bg-amber-50 text-amber-700 ring-amber-500/20">
                        <span class="w-1.5 h-1.5 rounded-full bg-amber-400 animate-pulse shrink-0"></span>
                        NOT ASSIGNED
                      </span>
                    </ng-template>
      
                    <div class="text-xs font-medium text-gray-500 flex items-center gap-1">
                      <svg class="w-3 h-3 text-gray-400 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                      </svg>
                      <span class="truncate max-w-[100px]">{{ user.assignedAdvisor?.name || 'No Advisor' }}</span>
                    </div>
                  </div>
                </td>
      
                <!-- ── Actions ── -->
                <td class="px-4 lg:px-6 py-3.5">
                  <div class="flex items-center justify-end">
                    <a
                      (click)="viewDetails(user)"
                      class="inline-flex items-center gap-1.5 px-3 py-1.5
                             bg-white border border-indigo-200 text-indigo-600
                             text-xs font-black rounded-lg cursor-pointer
                             hover:bg-indigo-600 hover:text-white hover:border-indigo-600
                             active:scale-95 transition-all duration-150">
                      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                      </svg>
                      VIEW
                    </a>
                  </div>
                </td>
      
              </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
      
      
      <!-- ═══════════════════════ PAGINATION ═══════════════════════ -->
      <div
        *ngIf="totalPages() > 1"
        class="animate-fade-up delay-4 flex flex-col sm:flex-row items-center justify-between gap-4
               mt-4 px-4 py-4 bg-white border border-gray-200 rounded-2xl shadow-sm">
      
        <!-- Page info -->
        <p class="text-sm text-gray-500 font-semibold">
          Page <span class="text-gray-800">{{ currentPage() }}</span>
          of
          <span class="text-gray-800">{{ totalPages() }}</span>
        </p>
      
        <!-- Mobile -->
        <div class="flex sm:hidden items-center gap-3">
          <button
            (click)="changePage(currentPage() - 1)"
            [disabled]="currentPage() === 1"
            class="w-11 h-11 flex items-center justify-center rounded-xl border border-gray-200 bg-white
                   hover:bg-indigo-50 hover:text-indigo-600 hover:border-indigo-200
                   disabled:opacity-40 disabled:cursor-not-allowed transition-all">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
            </svg>
          </button>
      
          <div class="px-5 py-2 rounded-xl bg-indigo-600 text-white text-sm font-black min-w-[74px] text-center shadow-md shadow-indigo-200">
            {{ currentPage() }} / {{ totalPages() }}
          </div>
      
          <button
            (click)="changePage(currentPage() + 1)"
            [disabled]="currentPage() === totalPages()"
            class="w-11 h-11 flex items-center justify-center rounded-xl border border-gray-200 bg-white
                   hover:bg-indigo-50 hover:text-indigo-600 hover:border-indigo-200
                   disabled:opacity-40 disabled:cursor-not-allowed transition-all">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
            </svg>
          </button>
        </div>
      
        <!-- Desktop -->
        <div class="hidden sm:flex flex-wrap items-center gap-2">
          <button
            (click)="changePage(currentPage() - 1)"
            [disabled]="currentPage() === 1"
            class="px-4 py-2 text-sm font-bold rounded-xl border border-gray-200 bg-white
                   hover:bg-indigo-50 hover:text-indigo-600 hover:border-indigo-200
                   disabled:opacity-40 disabled:cursor-not-allowed transition-all">
            ← Previous
          </button>
      
          @for (page of visiblePages(); track page) {
            <span *ngIf="page === '...'"
                  class="px-1.5 text-gray-400 font-bold select-none">…</span>
      
            <button
              *ngIf="page !== '...'"
              (click)="changePage(+page)"
              [ngClass]="currentPage() === +page
                ? 'page-active'
                : 'bg-white text-gray-700 border-gray-200 hover:bg-indigo-50 hover:text-indigo-600 hover:border-indigo-200'"
              class="w-10 h-10 text-sm font-bold rounded-xl border transition-all">
              {{ page }}
            </button>
          }
      
          <button
            (click)="changePage(currentPage() + 1)"
            [disabled]="currentPage() === totalPages()"
            class="px-4 py-2 text-sm font-bold rounded-xl border border-gray-200 bg-white
                   hover:bg-indigo-50 hover:text-indigo-600 hover:border-indigo-200
                   disabled:opacity-40 disabled:cursor-not-allowed transition-all">
            Next →
          </button>
        </div>
      </div>
      
      
      <!-- ═══════════════════════ DRAWER OVERLAY ═══════════════════════ -->
      @if (isDrawerOpen()) {
      <div
        class="fixed inset-0 z-40 bg-gray-900/25 backdrop-blur-sm transition-opacity duration-300 animate-fade-in"
        (click)="closeDrawer()">
      </div>
      }
      
      
      <!-- ═══════════════════════ DRAWER PANEL ═══════════════════════ -->
      <div
        class="drawer-panel fixed inset-y-0 right-0 z-50 w-full sm:w-[92%] md:w-[480px]
               bg-white shadow-2xl flex flex-col transform transition-transform duration-[380ms]"
        [class.translate-x-full]="!isDrawerOpen()"
        [class.translate-x-0]="isDrawerOpen()">
      
        @if (selectedUser(); as user) {
      
        <!-- Drawer header -->
        <div class="h-16 flex items-center justify-between px-6 border-b border-gray-100 bg-white shrink-0">
          <h2 class="text-lg font-black text-gray-800">User Details</h2>
          <button
            (click)="closeDrawer()"
            class="w-8 h-8 flex items-center justify-center rounded-lg text-gray-400
                   hover:text-gray-700 hover:bg-gray-100 active:scale-95 transition-all">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
      
        <!-- Scrollable body -->
        <div class="flex-1 overflow-y-auto p-5 sm:p-6 space-y-6">
      
          <!-- Avatar + Info -->
          <div class="flex flex-col items-center text-center pt-1">
            <div class="relative">
              <img
                [src]="'user.jpeg'"
                class="w-24 h-24 rounded-full object-cover ring-4 ring-gray-50 shadow-md"
                onerror="this.style.display='none'; this.nextElementSibling.style.display='flex'" />
              <!-- Fallback initial avatar -->
              <div class="w-24 h-24 rounded-full ring-4 ring-gray-50 shadow-md hidden
                          bg-indigo-100 text-indigo-700 font-black text-3xl items-center justify-center">
                {{ user?.name?.charAt(0)?.toUpperCase() }}
              </div>
              <span
                class="absolute bottom-1 right-1 w-5 h-5 border-4 border-white rounded-full"
                [ngClass]="getStatusDot(user.status)">
              </span>
            </div>
            <h3 class="mt-4 text-xl font-black text-gray-900">{{ user.name }}</h3>
            <p class="text-sm text-gray-400 mt-0.5">{{ user.role?.label }} • India</p>
            <span
              class="mt-2.5 px-3 py-1 rounded-full text-xs font-black uppercase tracking-wider border"
              [class]="_US.getStatusClass(user?.state)">
              {{ user?.state || 'Pending' }}
            </span>
          </div>
      
          <!-- ── Subscription card ── -->
          <div *ngIf="user?.subsctions" class="rounded-2xl overflow-hidden border border-gray-100 shadow-sm">
      
            <!-- Card header -->
            <div
              class="px-5 py-3 flex items-center justify-between"
              [ngClass]="user.subsctions.membershipType === 'Premium'
                ? 'bg-gradient-to-r from-indigo-600 to-violet-600'
                : 'bg-gray-100'">
              <div class="flex items-center gap-2">
                <svg
                  *ngIf="user.subsctions.membershipType === 'Premium'"
                  class="w-4 h-4 text-yellow-300 shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                </svg>
                <span
                  class="text-sm font-black"
                  [ngClass]="user.subsctions.membershipType === 'Premium' ? 'text-white' : 'text-gray-700'">
                  {{ user.subsctions.membershipType }} Plan
                </span>
              </div>
      
              <span
                class="px-2.5 py-0.5 rounded-full text-[10px] font-black uppercase tracking-wider inline-flex items-center gap-1"
                [ngClass]="user.subsctions.subscriptionStatus === 'active'
                  ? 'bg-white/15 text-white ring-1 ring-white/30'
                  : 'bg-red-400/20 text-red-200 ring-1 ring-red-300/30'">
                <span
                  class="inline-block w-1.5 h-1.5 rounded-full"
                  [ngClass]="user.subsctions.subscriptionStatus === 'active' ? 'bg-green-300 animate-pulse' : 'bg-red-300'">
                </span>
                {{ user.subsctions.subscriptionStatus }}
              </span>
            </div>
      
            <!-- Card body -->
            <div class="bg-white px-5 py-4 grid grid-cols-2 gap-4">
              <div>
                <p class="text-[10px] text-gray-400 font-black uppercase tracking-widest mb-0.5">Start Date</p>
                <p class="text-sm font-black text-gray-800">
                  {{ user.subsctions.subscriptionStartDate | date:'dd MMM yyyy' }}
                </p>
              </div>
              <div>
                <p class="text-[10px] text-gray-400 font-black uppercase tracking-widest mb-0.5">End Date</p>
                <p class="text-sm font-black text-gray-800">
                  {{ user.subsctions.subscriptionEndDate | date:'dd MMM yyyy' }}
                </p>
              </div>
              <div class="col-span-2">
                <p class="text-[10px] text-gray-400 font-black uppercase tracking-widest mb-0.5">Last Updated</p>
                <p class="text-sm font-black text-gray-800">
                  {{ user.subsctions.updatedAt | date:'dd MMM yyyy, hh:mm a' }}
                </p>
              </div>
              <div class="col-span-2">
                <p class="text-[10px] text-gray-400 font-black uppercase tracking-widest mb-0.5">Transaction ID</p>
                <p class="mono text-xs font-bold text-indigo-600 bg-indigo-50 px-3 py-1.5 rounded-lg truncate">
                  {{ user.subsctions.lastTransactionId || '—' }}
                </p>
              </div>
            </div>
      
            <!-- Days remaining progress -->
            <div
              *ngIf="user.subsctions.subscriptionStartDate && user.subsctions.subscriptionEndDate"
              class="px-5 pb-4 bg-white">
              <div class="flex justify-between text-[10px] text-gray-400 font-black uppercase tracking-widest mb-1.5">
                <span>Days Remaining</span>
                <span>{{ getDaysRemaining(user.subsctions.subscriptionEndDate) }} days left</span>
              </div>
              <div class="w-full h-2 bg-gray-100 rounded-full overflow-hidden">
                <div
                  class="h-full rounded-full sub-progress-bar"
                  [ngClass]="getDaysRemaining(user.subsctions.subscriptionEndDate) > 30
                    ? 'bg-gradient-to-r from-indigo-500 to-violet-500'
                    : getDaysRemaining(user.subsctions.subscriptionEndDate) > 10
                    ? 'bg-gradient-to-r from-amber-400 to-orange-400'
                    : 'bg-gradient-to-r from-red-400 to-rose-500'"
                  [style.width]="getSubscriptionProgress(user.subsctions.subscriptionStartDate, user.subsctions.subscriptionEndDate) + '%'">
                </div>
              </div>
            </div>
          </div>
      
          <!-- No subscription -->
          <div
            *ngIf="!user?.subsctions"
            class="rounded-2xl border border-dashed border-gray-200 bg-gray-50 px-5 py-8 text-center">
            <div class="w-10 h-10 rounded-xl bg-gray-100 flex items-center justify-center mx-auto mb-3">
              <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/>
              </svg>
            </div>
            <p class="text-sm font-bold text-gray-400">No active subscription</p>
            <p class="text-xs text-gray-300 mt-1">This user is on the free Basic plan.</p>
          </div>
      
          <!-- ── Edit form ── -->
          <form [formGroup]="editForm" (ngSubmit)="saveUser()" class="space-y-4" id="editUserForm">
      
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-1.5">Full Name</label>
              <input
                type="text"
                formControlName="name"
                class="input-field w-full rounded-xl border px-3.5 py-2.5 text-sm outline-none transition-all
                       focus:ring-2 focus:border-indigo-400"
                [ngClass]="editForm.get('name')?.touched && editForm.get('name')?.invalid
                  ? 'border-red-400 bg-red-50 focus:ring-red-500/20'
                  : 'border-gray-200 bg-gray-50 focus:bg-white focus:ring-indigo-500/20'" />
              <p *ngIf="editForm.get('name')?.touched && editForm.get('name')?.invalid"
                 class="text-xs text-red-500 mt-1 flex items-center gap-1">
                <svg class="w-3.5 h-3.5 shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
                </svg>
                Name is required.
              </p>
            </div>
      
            <!-- Phone (read-only with country dial) -->
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-1.5">Phone Number</label>
              <div class="flex border border-gray-200 rounded-xl overflow-hidden bg-gray-50
                          focus-within:ring-2 focus-within:ring-indigo-500/20 focus-within:border-indigo-400 transition-all">
                <button
                  type="button"
                  (click)="toggleDropdown($event)"
                  class="flex items-center gap-1.5 px-3 py-2.5 border-r border-gray-200
                         bg-gray-100 hover:bg-gray-200 text-sm font-semibold min-w-[90px] transition-colors">
                  <span class="text-base leading-none">{{ selectedCountry.flag }}</span>
                  <span class="text-gray-700">{{ selectedCountry.dial }}</span>
                  <span class="text-[10px] text-gray-400">{{ dropdownOpen ? '▲' : '▼' }}</span>
                </button>
      
                <div *ngIf="dropdownOpen"
                     class="absolute mt-11 z-50 w-72 bg-white border border-gray-200 rounded-xl shadow-xl overflow-hidden">
                  <div class="p-2.5 border-b border-gray-100">
                    <input
                      type="text"
                      [(ngModel)]="searchQuery"
                      [ngModelOptions]="{standalone: true}"
                      placeholder="Search country…"
                      class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-indigo-400"/>
                  </div>
                  <ul class="overflow-y-auto max-h-60 divide-y divide-gray-50">
                    <li
                      *ngFor="let country of filteredCountries"
                      (click)="selectCountry(country)"
                      class="flex items-center gap-2.5 px-3 py-2.5 cursor-pointer hover:bg-indigo-50 text-sm transition-colors"
                      [class.bg-indigo-50]="country.code === selectedCountry.code">
                      <span class="text-base w-6 text-center">{{ country?.flag }}</span>
                      <span class="flex-1 text-gray-700 font-medium">{{ country?.name }}</span>
                      <span class="text-gray-400 text-xs mono">{{ country?.dial }}</span>
                    </li>
                  </ul>
                </div>
      
                <input
                  type="tel"
                  placeholder="Your contact number"
                  [value]="user.phone"
                  formControlName="phone"
                  class="flex-1 px-3 py-2.5 text-sm bg-transparent outline-none text-gray-400 cursor-not-allowed"
                  readonly />
              </div>
              <p class="text-[11px] text-gray-400 mt-1.5 flex items-center gap-1">
                <svg class="w-3 h-3 shrink-0 text-gray-300" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clip-rule="evenodd"/>
                </svg>
                Phone number cannot be changed.
              </p>
            </div>
      
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-1.5">Email Address</label>
              <input
                type="email"
                formControlName="email"
                class="input-field w-full rounded-xl border px-3.5 py-2.5 text-sm outline-none transition-all
                       focus:ring-2 focus:border-indigo-400"
                [ngClass]="editForm.get('email')?.touched && editForm.get('email')?.invalid
                  ? 'border-red-400 bg-red-50 focus:ring-red-500/20'
                  : 'border-gray-200 bg-gray-50 focus:bg-white focus:ring-indigo-500/20'" />
              <p *ngIf="editForm.get('email')?.touched && editForm.get('email')?.invalid"
                 class="text-xs text-red-500 mt-1 flex items-center gap-1">
                <svg class="w-3.5 h-3.5 shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
                </svg>
                A valid email address is required.
              </p>
            </div>
      
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-1.5">Approval State</label>
              <div class="relative">
                <select
                  formControlName="state"
                  class="input-field w-full appearance-none rounded-xl border border-gray-200 bg-gray-50
                         px-3.5 py-2.5 pr-9 text-sm outline-none cursor-pointer
                         focus:bg-white focus:border-indigo-400 focus:ring-2 focus:ring-indigo-500/20 transition-all">
                  <option value="Approved">✅ Approved</option>
                  <option value="Pending">⏳ Pending</option>
                  <option value="Reject">❌ Rejected</option>
                </select>
                <svg class="absolute right-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400 pointer-events-none"
                     fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M19 9l-7 7-7-7"/>
                </svg>
              </div>
            </div>
      
          </form>
        </div>
      
        <!-- Drawer footer -->
        <div class="p-5 border-t border-gray-100 bg-gray-50/80 shrink-0">
          <div class="flex gap-3">
            <button
              type="submit"
              form="editUserForm"
              [disabled]="editForm.invalid || isSaving"
              class="flex-1 bg-indigo-600 text-white px-4 py-2.5 rounded-xl font-bold
                     hover:bg-indigo-700 active:scale-[.98] transition-all shadow-sm
                     disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100
                     flex items-center justify-center gap-2">
              <svg
                *ngIf="isSaving"
                class="animate-spin w-4 h-4 text-white shrink-0" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
              </svg>
              <svg *ngIf="!isSaving" class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"/>
              </svg>
              {{ isSaving ? 'Saving…' : 'Save Changes' }}
            </button>
            <button
              (click)="closeDrawer()"
              class="flex-1 bg-white border border-gray-200 text-gray-700 px-4 py-2.5 rounded-xl
                     font-bold hover:bg-gray-100 active:scale-[.98] transition-all">
              Cancel
            </button>
          </div>
        </div>
      
        }
      </div><!-- /drawer -->
      
      
      <!-- ═══════════════════════ ADD USER MODAL ═══════════════════════ -->
      <div
        *ngIf="showUserModal"
        @fadeAnimation
        class="modal-overlay fixed inset-0 bg-black/50 backdrop-blur-sm
               flex items-center justify-center z-50 p-4"
        (click)="showUserModal = false">
      
        <div
          @modalAnimation
          class="modal-card bg-white w-full max-w-md rounded-[1.75rem] sm:rounded-[2rem]
                 p-6 sm:p-8 shadow-2xl relative max-h-[90vh] overflow-y-auto"
          (click)="$event.stopPropagation()">
      
          <!-- Close -->
          <button
            (click)="showUserModal = false"
            class="absolute top-5 right-5 w-8 h-8 flex items-center justify-center rounded-full
                   text-gray-400 hover:text-gray-700 hover:bg-gray-100 active:scale-95 transition-all">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
      
          <!-- Modal header -->
          <div class="text-center mb-7">
            <div class="w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg shadow-indigo-200"
                 style="background:linear-gradient(135deg,#6366f1,#8b5cf6)">
              <svg class="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"/>
              </svg>
            </div>
            <h2 class="text-2xl font-black text-gray-900">Add New User</h2>
            <p class="text-gray-400 text-sm mt-1">Create a new account for your team.</p>
          </div>
      
          <form [formGroup]="userForm" (ngSubmit)="onSubmit()" class="space-y-4">
      
            <!-- Name -->
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-1.5 ml-0.5">Full Name</label>
              <input
                type="text"
                formControlName="name"
                placeholder="e.g. Priya Sharma"
                class="input-field w-full bg-gray-50 border border-gray-200 rounded-2xl px-5 py-3.5 text-sm
                       outline-none transition-all focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-500/20"
                [class.border-red-400]="userForm.get('name')?.touched && userForm.get('name')?.invalid"
                [class.bg-red-50]="userForm.get('name')?.touched && userForm.get('name')?.invalid" />
            </div>
      
            <!-- Email -->
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-1.5 ml-0.5">Email Address</label>
              <input
                type="email"
                formControlName="email"
                placeholder="name@company.com"
                class="input-field w-full bg-gray-50 border border-gray-200 rounded-2xl px-5 py-3.5 text-sm
                       outline-none transition-all focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-500/20"
                [class.border-red-400]="userForm.get('email')?.touched && userForm.get('email')?.invalid"
                [class.bg-red-50]="userForm.get('email')?.touched && userForm.get('email')?.invalid" />
            </div>
      
            <!-- Phone with country selector -->
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-1.5 ml-0.5">Phone Number</label>
              <div class="relative flex border border-gray-200 rounded-2xl overflow-visible bg-gray-50
                          focus-within:ring-2 focus-within:ring-indigo-500/20 focus-within:border-indigo-400 transition-all">
      
                <div class="relative shrink-0">
                  <button
                    type="button"
                    (click)="toggleDropdown($event)"
                    class="flex items-center gap-2 px-4 py-3.5 bg-gray-100 border-r border-gray-200
                           rounded-l-2xl hover:bg-gray-200 min-w-[100px] transition-colors">
                    <span class="text-base">{{ selectedCountry?.flag }}</span>
                    <span class="text-sm font-semibold text-gray-700">{{ selectedCountry?.dial }}</span>
                    <span class="text-[10px] text-gray-400">{{ dropdownOpen ? '▲' : '▼' }}</span>
                  </button>
      
                  <div
                    *ngIf="dropdownOpen"
                    class="absolute top-full left-0 mt-2 z-50 w-[92vw] sm:w-72 max-w-[320px]
                           bg-white border border-gray-200 rounded-2xl shadow-2xl overflow-hidden">
                    <div class="p-2.5 border-b border-gray-100">
                      <input
                        type="text"
                        [(ngModel)]="searchQuery"
                        [ngModelOptions]="{standalone:true}"
                        placeholder="Search country…"
                        class="w-full border border-gray-200 rounded-xl px-3.5 py-2 text-sm outline-none
                               focus:border-indigo-400 transition-colors"/>
                    </div>
                    <ul class="max-h-56 overflow-y-auto divide-y divide-gray-50">
                      <li
                        *ngFor="let country of filteredCountries"
                        (click)="selectCountry(country)"
                        class="px-4 py-2.5 hover:bg-indigo-50 cursor-pointer flex items-center justify-between text-sm transition-colors">
                        <span class="flex items-center gap-2.5">
                          <span>{{ country.flag }}</span>
                          <span class="text-gray-700 font-medium">{{ country.name }}</span>
                        </span>
                        <span class="text-gray-400 mono text-xs">{{ country.dial }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
      
                <input
                  type="tel"
                  formControlName="phone"
                  minlength="7"
                  maxlength="15"
                  placeholder="00000 00000"
                  class="flex-1 px-4 py-3.5 text-sm bg-transparent outline-none" />
              </div>
            </div>
      
            <!-- Password -->
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-1.5 ml-0.5">Password</label>
              <div class="relative">
                <input
                  [type]="passwordVisible ? 'text' : 'password'"
                  formControlName="password"
                  placeholder="••••••••"
                  class="input-field w-full bg-gray-50 border border-gray-200 rounded-2xl px-5 py-3.5 pr-14 text-sm
                         outline-none transition-all focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-500/20"
                  [class.border-red-400]="userForm.get('password')?.touched && userForm.get('password')?.invalid"
                  [class.bg-red-50]="userForm.get('password')?.touched && userForm.get('password')?.invalid" />
                <button
                  type="button"
                  (click)="passwordVisible = !passwordVisible"
                  class="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700 transition-colors">
                  <!-- Eye open -->
                  <svg *ngIf="!passwordVisible" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                  </svg>
                  <!-- Eye closed -->
                  <svg *ngIf="passwordVisible" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/>
                  </svg>
                </button>
              </div>
            </div>
      
            <!-- Note -->
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-1.5 ml-0.5">Message / Note</label>
              <textarea
                formControlName="statusReason"
                rows="3"
                placeholder="Enter approval or rejection note…"
                class="input-field w-full bg-gray-50 border border-gray-200 rounded-2xl px-5 py-3.5 text-sm
                       outline-none transition-all focus:border-indigo-400 focus:bg-white
                       focus:ring-2 focus:ring-indigo-500/20 resize-none">
              </textarea>
            </div>
      
            <!-- Submit -->
            <div class="pt-2">
              <button
                type="submit"
                [disabled]="userForm.invalid || userForm.pending"
                class="w-full bg-indigo-600 text-white py-3.5 rounded-2xl text-sm font-black
                       shadow-lg shadow-indigo-200 hover:bg-indigo-700 hover:shadow-xl
                       active:scale-[.98] transition-all
                       disabled:bg-gray-200 disabled:text-gray-400 disabled:shadow-none disabled:active:scale-100">
                {{ userForm.pending ? 'Creating…' : 'Create User' }}
              </button>
            </div>
      
          </form>
        </div>
      </div>
